module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-warp"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('p', {
    staticClass: "f18 t-c pb30"
  }, [_vm._v("俺来也合作平台")]), _vm._v(" "), _c('el-form', {
    ref: "loginForm",
    attrs: {
      "size": "mini",
      "model": _vm.loginForm,
      "rules": _vm.rules
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "way"
    }
  }, [_c('el-select', {
    staticClass: "w100p",
    model: {
      value: (_vm.loginForm.login_type),
      callback: function($$v) {
        _vm.$set(_vm.loginForm, "login_type", $$v)
      },
      expression: "loginForm.login_type"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "账号登录",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "手机号登录",
      "value": "2"
    }
  })], 1)], 1), _vm._v(" "), (_vm.loginForm.login_type == 1) ? _c('div', [_c('el-form-item', {
    attrs: {
      "prop": "username"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off",
      "placeholder": "用户名"
    },
    model: {
      value: (_vm.loginForm.username),
      callback: function($$v) {
        _vm.$set(_vm.loginForm, "username", $$v)
      },
      expression: "loginForm.username"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off",
      "placeholder": "8~16位包含数字、大小写字母、特殊符号其中两种"
    },
    model: {
      value: (_vm.loginForm.password),
      callback: function($$v) {
        _vm.$set(_vm.loginForm, "password", $$v)
      },
      expression: "loginForm.password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "imgCaptcha"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off",
      "placeholder": "验证码"
    },
    model: {
      value: (_vm.loginForm.imgCaptcha),
      callback: function($$v) {
        _vm.$set(_vm.loginForm, "imgCaptcha", $$v)
      },
      expression: "loginForm.imgCaptcha"
    }
  }, [_c('template', {
    slot: "append"
  }, [_c('img', {
    staticClass: "cursor",
    attrs: {
      "src": _vm.imgCaptchaUrl,
      "height": "28",
      "alt": "",
      "id": "imgCaptcha"
    },
    on: {
      "click": function($event) {
        return _vm.getImgCaptcha()
      }
    }
  })])], 2)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.loginForm.login_type == 2) ? _c('div', [_c('el-form-item', {
    attrs: {
      "prop": "mobile"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off",
      "placeholder": "手机号"
    },
    model: {
      value: (_vm.loginForm.mobile),
      callback: function($$v) {
        _vm.$set(_vm.loginForm, "mobile", $$v)
      },
      expression: "loginForm.mobile"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "captcha",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off",
      "placeholder": "验证码"
    },
    model: {
      value: (_vm.loginForm.captcha),
      callback: function($$v) {
        _vm.$set(_vm.loginForm, "captcha", $$v)
      },
      expression: "loginForm.captcha"
    }
  }, [_c('template', {
    slot: "append"
  }, [_c('el-button', {
    attrs: {
      "type": "text",
      "loading": _vm.loading1,
      "disabled": _vm.smsBtnDisabled
    },
    on: {
      "click": function($event) {
        return _vm.smsSend()
      }
    }
  }, [_vm._v(_vm._s(_vm.smsBtn))])], 1)], 2)], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": function($event) {
        return _vm.submitForm('loginForm')
      }
    }
  }, [_vm._v("登录")])], 1)], 1)], 1), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', [_c('div', {
    staticStyle: {
      "padding": "10px 0",
      "text-align": "center",
      "font-size": "12px"
    }
  }, [_c('div', [_vm._v(" © Copyright 2015-2022 IMC AII Rights Reserved")]), _vm._v(" "), _c('div', [_vm._v("\n                俺来也(上海)网络科技有限公司\n                "), _c('a', {
    staticStyle: {
      "color": "#1E80FF"
    },
    attrs: {
      "href": "https://beian.miit.gov.cn/",
      "target": "_blank"
    }
  }, [_vm._v("沪ICP备14051190号-7")]), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "20px",
      "vertical-align": "middle"
    },
    attrs: {
      "src": "http://website.anlaiye.com/uploadfile/image/20220721/20220721090341_79922.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('a', {
    staticStyle: {
      "color": "#1E80FF"
    },
    attrs: {
      "href": "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31010402003336",
      "target": "_blank"
    }
  }, [_vm._v("沪公网安备31010402003336号")])]), _vm._v(" "), _c('div', [_vm._v("客服电话:400-6869-933")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3318b495"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/views/passport/login.vue
// module id = 900
// module chunks = 0